import React, { PureComponent, Fragment } from "react"
import NavBar from "./navigation/nav-bar"
import { Link } from 'react-router-dom'
import MediaList from './media-list'
import FrontSection1Bg from '../images/front-section1-bg.png'
import FrontSection2Bg from '../images/front-section2-bg.png'
import IconParticipants from '../images/icon-square-participants.svg'
import IconInvited from '../images/icon-square-invited.svg'
import IconEngagementRatio from '../images/icon-square-engagement-ratio.svg'
import DriverStatBar from './ui/driver-stat-bar'
import DriverResultMap from './ui/driver-result-map'
import DashBoardIconVai from '../images/dashboard-icon-vai.svg'
import DashBoardIconThemes from '../images/dashboard-icon-themes.svg'
import DashBoardIconDrivers from '../images/dashboard-icon-drivers.svg'
import DashBoardIconStatements from '../images/dashboard-icon-statements.svg'
import CompactStatRow from './ui/compact-stat-row'
import { map } from 'lodash-es'
import { sortingService } from '../utilities/sortingService'
import Button from './ui/button'
import NavMainAftergameLinks from './navigation/nav-main-aftergame-links'
import ParameterFilter from './ui/parameter-filter'
import { getThemeStyle } from '../utilities/helpers'
import { formPagePath } from '../utilities/route'
import NavStatistics from './navigation/nav-statistics'
import ReferenceKPIs from './reference-KPIs'
import { Survey } from '../utilities/Survey'
import { mergeWithStatistics, likertResponseToPercentage } from '../utilities/statistics'

class SummaryPage extends PureComponent {

  constructor(props) {
    super(props);
    const _surveyBeingEdited = sessionStorage.getItem("surveyBeingEdited") || false
    this.state = {
      surveyBeingEdited: !!(_surveyBeingEdited && _surveyBeingEdited === "true")
    };
  }

  handleFiltersChange = value => {
    this.props.onSetFilters(value);
  }

  checkIfResults = (results) => {
    const totalResult =  results.reduce( function(a, b){
      if (b["result"] !== null) {
        return a + b["result"];
      }
      else {
        return a;
      }
    }, null);

    return !!totalResult;
  }

  render() {
    const {
      match: {
        params: { surveyId, languageCode },
      },
      surveyStatistics,
      respondentParameters,
      questionnaire,
      questionnaire: {
        canViewAfterGame,
        areProgressReportsActive,
        logo,
        media,
        isAfterGameGuest,
        isDialogueActive,
        canAnswer
      },
      useTranslate,
      filters,
      afterGameRespondentCountOverview: {
        answeredRespondentCount,
        invitedRespondentCount,
        engagementPercentage
      },
      improvementProject
    } = this.props;

    const to = formPagePath(languageCode, surveyId, 'finish');
    const toEditAnswers = formPagePath(languageCode, surveyId);

    const startEditingSurvey = () => {
      sessionStorage.setItem("surveyBeingEdited", "true");
      this.setState({surveyBeingEdited: true});
    }

    const survey = new Survey(questionnaire.catalysts, respondentParameters)
    let themes
    let drivers
    let statementsTop5ByResult
    let statementsBottom5ByResult
    let statementsTop5ByImportance
    let statementsBottom5Byimportance
    let vaiResult
    const notEnoughRespondents = surveyStatistics.__typename === 'NotEnoughRespondentsError'
    if (!notEnoughRespondents) {
      // Themes results
      themes = mergeWithStatistics(survey.getThemes(), surveyStatistics.themes).map((theme) => {
        return {
          title: theme.title,
          result: likertResponseToPercentage(theme.statistics.aggregatedResponse)
        }
      });
      // Drivers results
      drivers = mergeWithStatistics(survey.getDrivers(), surveyStatistics.drivers).map((driver) => {
        return {
          title: driver.title,
          result: likertResponseToPercentage(driver.statistics.aggregatedResponse),
          importance: driver.statistics.aggregatedImportance,
          surveyThemeIndex: survey.getSurveyThemeIndex(survey.getThemeIdByDriverId(driver.id))
        }
      })
      const isAfterGame = (canViewAfterGame || isAfterGameGuest)
      // Statements results
      const statements = mergeWithStatistics(survey.getLikertQuestions(), surveyStatistics.questions).map((question) => {
        return {
          title: question.title,
          result: likertResponseToPercentage(question.statistics.aggregatedResponse),
          rate: question.statistics.aggregatedImportance,
          surveyThemeIndex: survey.getSurveyThemeIndex(survey.getThemeIdByLikertQuestionId(question.id)),
          respondentGroups: isAfterGame ? survey.getRespondentGroups(question.id, 'likert') : undefined
        }
      }).filter(s => s.result !== undefined);
      statementsTop5ByResult = [...statements].sort(sortingService.byResult(false)).slice(0, 5);
      statementsBottom5ByResult = [...statements].sort(sortingService.byResult(true)).slice(0, 5);
      statementsTop5ByImportance = [...statements].sort(sortingService.byRating(false)).slice(0, 5);
      statementsBottom5Byimportance = [...statements].sort(sortingService.byRating(true)).slice(0, 5);
      // Vai result
      vaiResult = this.checkIfResults(statements) ? likertResponseToPercentage(surveyStatistics.overallAggregatedResponse) : null;
    }

    return (
      <section className="aftergame-page dashboard-page pb-5">
        <div className="dashboard-hero">
          <div className="aftergame-page-container nav-container">
            <NavBar
              afterGame={true}
              inverse={true}
              logo={logo}
              canViewAfterGame={canViewAfterGame}
              isAfterGameGuest={isAfterGameGuest}
            >
              {(canViewAfterGame || isAfterGameGuest) &&
                <NavMainAftergameLinks
                  activePage={"statistics"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  isDialogueActive={isDialogueActive}
                  showProgressReports={areProgressReportsActive}
                  improvementProject={improvementProject}
                />
              }
            </NavBar>
          </div>
          <div className="hero-bg">
            <img src={FrontSection1Bg} className="img-1" alt="Shapes"/>
          </div>
          <div className={`hero-content aftergame-page-container ${(!canViewAfterGame && !isAfterGameGuest) ? 'before-aftergame' : ''}`}>
            <div className="finish-page__intro">
              { (!canViewAfterGame && !isAfterGameGuest) ?
                <Fragment>
                  <h1>{useTranslate("survey_finished.your_statistics_page_title")}</h1>
                  <div className="stats-description">
                    <p>{useTranslate("survey_finished.your_statistics_page_description")}</p>
                    { (!canViewAfterGame && canAnswer) &&
                      <div>
                        <Button
                          as={Link}
                          to={toEditAnswers}
                          onClick={() => startEditingSurvey()}
                          size={"md"}
                        >
                          {useTranslate("data_vault.edit_answers_button")}
                        </Button>
                      </div>
                    }
                  </div>
                </Fragment>
                :
                <Fragment>
                  <h1>{useTranslate("dashboard.overview_title")}</h1>
                  <div>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: useTranslate("dashboard.overview_description"),
                      }}
                    />
                  </div>
                  <div className="hero-stats">
                    <div className="card">
                      <img src={IconParticipants} alt="icon"/>
                      <div className="card-content">
                        <span className="title">{useTranslate("dashboard.participants")}</span>
                        <span className="result">{answeredRespondentCount}</span>
                      </div>
                    </div>
                    <div className="card">
                      <img src={IconInvited} alt="icon"/>
                      <div className="card-content">
                        <span className="title">{useTranslate("dashboard.invited")}</span>
                        <span className="result">{invitedRespondentCount}</span>
                      </div>
                    </div>
                    <div className="card">
                      <img src={IconEngagementRatio} alt="icon"/>
                      <div className="card-content">
                        <span className="title">{useTranslate("dashboard.engagement_ratio")}</span>
                        <span className="result">{engagementPercentage}%</span>
                      </div>
                    </div>
                  </div>
                </Fragment>
              }

              <NavStatistics
                activePage={"overview"}
                languageCode={languageCode}
                surveyId={surveyId}
                useTranslate={useTranslate}
                questionnaire={questionnaire}
              />
            </div>
          </div>
        </div>
        <div className="dashboard-main">
          <div className="section-bg">
            <img src={FrontSection2Bg} className="img-1" alt="Shapes"/>
          </div>
          <div className="aftergame-page-container finish-page__stats">
            {(canViewAfterGame || isAfterGameGuest) &&
              <div className="finish-page__filters">
                <ParameterFilter
                  filters={filters}
                  handleFiltersChange={this.handleFiltersChange}
                  respondentParameters={respondentParameters}
                  isAfterGameGuest={isAfterGameGuest}
                  useTranslate={useTranslate}
                  labelInside={false}
                />
              </div>
            }

            <div className="card overview-card">
              <div className="overview-card-header">
                <img src={DashBoardIconVai} className="section-icon" alt="icon"/>
                <div>
                  <h2>{useTranslate("dashboard.dashboard_section_vai_title")}</h2>
                  <p style={{ maxWidth: 'none' }}>{useTranslate("dashboard.dashboard_section_vai_description")}</p>
                </div>
              </div>
              {!notEnoughRespondents ?
                <DriverStatBar result={vaiResult} useTranslate={useTranslate}/>
                :
                <p className="no-results">{useTranslate("data_vault.no_results_for_parameter")}</p>
              }
              <ReferenceKPIs />
            </div>
            <div className="card overview-card">
              <div className="overview-card-header">
                <img src={DashBoardIconThemes} className="section-icon" alt="icon"/>
                <div>
                  <h2>{useTranslate("dashboard.dashboard_section_themes_title")}</h2>
                  <p>{useTranslate("dashboard.dashboard_section_themes_description")}</p>
                </div>
              </div>
              {!notEnoughRespondents ?
                <Fragment>
                  <div className="dashboard-theme-stats">
                    {map(themes, (theme, index) => (
                      <div className="theme-stat" key={index}>
                        <div className="theme-title">{theme.title}</div>
                        <DriverStatBar result={theme.result} useTranslate={useTranslate} barColor={getThemeStyle(index).bgColor}/>
                      </div>
                    ))}
                  </div>
                  <Button
                    as={Link}
                    to={`${to}/themes`}
                    className={"more-details-btn"}
                    size={"sm"}
                    kind={"gray"}
                    addArrow={true}
                  >
                    {useTranslate("data_vault.more_details")}
                  </Button>
                </Fragment>
                :
                <p className="no-results">{useTranslate("data_vault.no_results_for_parameter")}</p>
              }
            </div>

            <div className="card overview-card">
              <div className="overview-card-header">
                <img src={DashBoardIconDrivers} className="section-icon" alt="icon"/>
                <div>
                  <h2>{useTranslate("dashboard.dashboard_section_drivers_title")}</h2>
                  <p>{useTranslate("dashboard.dashboard_section_drivers_description")}</p>
                </div>
              </div>
              {!notEnoughRespondents ?
                <Fragment>
                  <DriverResultMap drivers={drivers} useTranslate={useTranslate} />
                  <Button
                    as={Link}
                    to={`${to}/drivers`}
                    className={"more-details-btn"}
                    size={"sm"}
                    kind={"gray"}
                    addArrow={true}
                  >
                    {useTranslate("data_vault.more_details")}
                  </Button>
                </Fragment>
                :
                <p className="no-results">{useTranslate("data_vault.no_results_for_parameter")}</p>
              }
            </div>

            <div className="card overview-card" style={{marginBottom: "1px"}}>
              <div className="overview-card-header mb-0">
                <img src={DashBoardIconStatements} className="section-icon" alt="icon"/>
                <div>
                  <h2>{useTranslate("dashboard.dashboard_section_statements_title")}</h2>
                  <p className="mb-0">{useTranslate("dashboard.dashboard_section_statements_description")}</p>
                </div>
              </div>
              {!notEnoughRespondents &&
                this.checkIfResults(statementsBottom5ByResult) &&
                this.checkIfResults(statementsTop5ByImportance) &&
                this.checkIfResults(statementsBottom5Byimportance) &&
                <Button
                  as={Link}
                  to={`${to}/statements`}
                  className={"more-details-btn"}
                  size={"sm"}
                  kind={"gray"}
                  addArrow={true}
                >
                  {useTranslate("data_vault.more_details")}
                </Button>
              }
            </div>
            <div className="card overview-card" style={{marginBottom: "1px"}}>
              <div className="overview-card-header">
                <h3>{useTranslate("dashboard.top_5_statements_by_result")}</h3>
              </div>
              {!notEnoughRespondents ?
                map(statementsTop5ByResult, (statement, index) => (
                  <CompactStatRow
                    key={index}
                    index={index + 1}
                    title={statement.title}
                    result={statement.result}
                    rate={statement.rate}
                    surveyThemeIndex={statement.surveyThemeIndex}
                    respondentGroups={statement.respondentGroups}
                    showLabels={index === 0}
                    useTranslate={useTranslate}
                  />
                ))
                :
                <p className="no-results">{useTranslate("data_vault.no_results_for_parameter")}</p>
              }
            </div>
            <div className="card overview-card" style={{marginBottom: "1px"}}>
              <div className="overview-card-header">
                <h3>{useTranslate("dashboard.bottom_5_statements_by_result")}</h3>
              </div>
              {!notEnoughRespondents ?
                map(statementsBottom5ByResult, (statement, index) => (
                  <CompactStatRow
                    key={index}
                    index={index + 1}
                    title={statement.title}
                    result={statement.result}
                    rate={statement.rate}
                    surveyThemeIndex={statement.surveyThemeIndex}
                    respondentGroups={statement.respondentGroups}
                    showLabels={index === 0}
                    useTranslate={useTranslate}
                  />
                ))
                :
                <p className="no-results">{useTranslate("data_vault.no_results_for_parameter")}</p>
              }
            </div>
            <div className="card overview-card" style={{marginBottom: "1px"}}>
              <div className="overview-card-header">
                <h3>{useTranslate("dashboard.top_5_statements_by_importance")}</h3>
              </div>
              {!notEnoughRespondents ?
                map(statementsTop5ByImportance, (statement, index) => (
                  <CompactStatRow
                    key={index}
                    index={index + 1}
                    title={statement.title}
                    result={statement.result}
                    rate={statement.rate}
                    surveyThemeIndex={statement.surveyThemeIndex}
                    respondentGroups={statement.respondentGroups}
                    showLabels={index === 0}
                    useTranslate={useTranslate}
                  />
                ))
                :
                <p className="no-results">{useTranslate("data_vault.no_results_for_parameter")}</p>
              }
            </div>
            <div className="card overview-card mb-5">
              <div className="overview-card-header">
                <h3>{useTranslate("dashboard.bottom_5_statements_by_importance")}</h3>
              </div>
              {!notEnoughRespondents ?
                map(statementsBottom5Byimportance, (statement, index) => (
                  <CompactStatRow
                    key={index}
                    index={index + 1}
                    title={statement.title}
                    result={statement.result}
                    rate={statement.rate}
                    surveyThemeIndex={statement.surveyThemeIndex}
                    respondentGroups={statement.respondentGroups}
                    showLabels={index === 0}
                    useTranslate={useTranslate}
                  />
                ))
                :
                <p className="no-results">{useTranslate("data_vault.no_results_for_parameter")}</p>
              }
            </div>

            <div className="card overview-card w-100 mb-5">
              <section className="about about--finish d-flex align-items-center justify-space-between">
                <div className="about-container">
                  <div>
                    <div className="about__description mb-0">
                      <h4 className="mb-3">
                        {useTranslate("landing.about_title")}
                      </h4>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: useTranslate("landing.about_paragraph_1"),
                        }}
                      />
                      {!useTranslate("landing.about_paragraph_2").includes("Velit offiscia consequat") &&
                        <p
                          dangerouslySetInnerHTML={{
                            __html: useTranslate("landing.about_paragraph_2"),
                          }}
                        />
                      }
                    </div>
                  </div>
                  <MediaList useTranslate={useTranslate} media={media} />
                </div>
              </section>

            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default SummaryPage



// WEBPACK FOOTER //
// ./src/components/summary-page.js